var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconInfo02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 15"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7.333,
  cy: 7.333,
  r: 6.667,
  stroke: "#000",
  strokeWidth: 1.333
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.334,
  cy: 4.667,
  r: 0.667,
  fill: "#000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M6.667 6H8v4.667H6.667z"
})));
export default SvgIconInfo02;